import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [deleteUser, setDeleteUser] = useState(null);
  const [menuOpen, setMenuOpen] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = () => {
    axios
      .get("https://api.livestockify.com/api/admin/users", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        const mapped = res.data.map((u, index) => ({
          id: u.uuid || u.id || u.email || `user-${index}`, // ✅ stable key
          firstName: u.firstName || "",
          lastName: u.lastName || "",
          phone: u.phoneNumber || "",
          email: u.email || "",
          userType: u.userType || "",
          devices: u.deviceCount || 0,
        }));
        setUsers(mapped);
      })
      .catch(console.error);
  };

  const handleDelete = async () => {
    try {
      await axios.delete(
        `https://api.livestockify.com/api/admin/users/uuid/${deleteUser}`,
      );
      setDeleteUser(null);
      fetchUsers();
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete user");
    }
  };

  const filtered = users.filter((u) =>
    `${u.firstName} ${u.lastName} ${u.userType}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );

  const sorted = [...filtered].sort((a, b) => {
    const nameA = a.firstName || "";
    const nameB = b.firstName || "";
    return sortOrder === "asc"
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA);
  });

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-6 overflow-y-auto">
        {/* ================= DESKTOP HEADER (UNCHANGED) ================= */}

        <div className="hidden md:flex items-center justify-between mb-6">
          {/* LEFT */}
          <h1 className="text-xl font-semibold">Users</h1>

          {/* RIGHT CONTROLS */}
          <div className="flex items-center gap-4">
            {/* SEARCH */}
            <div className="relative">
              <input
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="border rounded-md  px-4 py-2 pl-10 text-sm w-64"
              />
              {/* <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
        🔍
      </span> */}
            </div>

            {/* SORT */}
            <div className="flex items-center gap-2">
              <span className="text-sm font-medium">Sort By</span>
              <select
                value={sortOrder}
                onChange={(e) => setSortOrder(e.target.value)}
                className="border rounded-md px-3 py-2 text-sm"
              >
                <option value="asc">Name (A–Z)</option>
                <option value="desc">Name (Z–A)</option>
              </select>
            </div>

            {/* ADD USER */}
            <button
              onClick={() => navigate("/add-user")}
              className="border rounded-md px-4 py-2 text-sm font-medium flex items-center gap-1"
            >
              + Add User
            </button>
          </div>
        </div>

        {/* ================= MOBILE / TABLET HEADER ================= */}
        <div className="md:hidden mb-4">
          {/* Kuppismart Logo – Mobile / Tablet only */}
          <div className="flex justify-center mb-2">
            <img
              src="http://res.cloudinary.com/dt8emxboh/image/upload/v1766945624/lfuftjjhgmcebxsn0jsz.png"
              alt="Kuppismart"
              className="h-10"
            />
          </div>

          <h1 className="text-lg font-semibold mb-3">Users</h1>

          <div className="flex gap-2 mb-3">
            <input
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="flex-1 border px-3 py-2 rounded-md text-sm"
            />

            <button
              onClick={() => setSortOrder(sortOrder === "asc" ? "desc" : "asc")}
              className="border px-3 py-2 rounded-md text-sm"
            >
              ⇅
            </button>
          </div>

          <button
            onClick={() => navigate("/add-user")}
            className="w-full bg-green-700 text-white py-2 rounded-md text-sm"
          >
            Add User
          </button>
        </div>

        {/* ================= DESKTOP TABLE (UNCHANGED) ================= */}
        <div className="hidden md:block">
          <table className="w-full text-sm border">
            <thead className="bg-green-700 text-white">
              <tr>
                {[
                  "First Name",
                  "Last Name",
                  "Phone",
                  "Email",
                  "User Type",
                  "No of Devices",
                  "",
                  "",
                ].map((h) => (
                  <th key={h} className="p-2 text-center">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {sorted.map((u, i) => (
                <tr key={u.id} className={i % 2 ? "bg-green-100" : ""}>
                  <td className="p-2">{u.firstName}</td>
                  <td className="p-2">{u.lastName}</td>
                  <td className="p-2">{u.phone}</td>
                  <td className="p-2">{u.email}</td>
                  <td className="p-2">{u.userType}</td>
                  <td className="p-2 text-center">{u.devices}</td>

                  <td
                    className="p-2 text-green-700 cursor-pointer"
                    onClick={() => navigate(`/users/edit/${u.id}`)}
                  >
                    Edit
                  </td>

                  <td
                    className="p-2 text-red-600 cursor-pointer"
                    onClick={() => setDeleteUser(u.id)}
                  >
                    Delete
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ================= MOBILE / TABLET CARDS ================= */}
        <div className="md:hidden space-y-4">
          {sorted.map((u) => (
            <div
              key={u.id}
              className="border rounded-xl p-4 bg-white shadow-sm relative"
            >
              <div className="flex justify-between">
                <div>
                  <p className="text-green-700 font-semibold">
                    {u.firstName} {u.lastName}
                  </p>
                  <p className="text-xs text-gray-500">{u.userType}</p>
                </div>

                <button
                  onClick={() => setMenuOpen(menuOpen === u.id ? null : u.id)}
                >
                  ⋮
                </button>

                {menuOpen === u.id && (
                  <div className="absolute right-3 top-10 bg-white border rounded shadow text-sm z-10">
                    <button
                      onClick={() => navigate(`/users/edit/${u.id}`)}
                      className="block px-4 py-2 hover:bg-gray-100 w-full text-left"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => setDeleteUser(u.id)}
                      className="block px-4 py-2 text-red-600 hover:bg-gray-100 w-full text-left"
                    >
                      Delete
                    </button>
                  </div>
                )}
              </div>

              <div className="mt-3 text-sm space-y-1">
                <p>📞 {u.phone}</p>
                <p>✉️ {u.email}</p>
                <p>📟 Devices: {u.devices}</p>
              </div>
            </div>
          ))}
        </div>

        {/* ================= DELETE MODAL ================= */}
        {deleteUser && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded space-y-4">
              <p>Are you sure you want to proceed this deletion</p>
              <div className="flex justify-end gap-4">
                <button onClick={() => setDeleteUser(null)}>Cancel</button>
                <button
                  onClick={handleDelete}
                  className="bg-red-600 text-white px-4 py-1 rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
